module.exports = __webpack_public_path__ + "static/media/logo.87b92bc2.png";